import Stock from "../Stock/Stock";
import { useCartItemContext } from "./CartItem.context";

type CartItemStockProps = {
  className?: string;
};

const CartItemStock = ({ className }: CartItemStockProps) => {
  const { item } = useCartItemContext();

  return (
    <Stock
      item={item}
      type="cart"
      className={className}
    />
  );
};

CartItemStock.displayName = "CartItemStock";

export default CartItemStock;
